import InputCheckbox from "@/components/input-checkbox/InputCheckbox";
import InputText from "@/components/input-text/InputText";
import { literals } from "@/constants/literals";
import { formatBooleanText, formatOptionalText } from "@/lib/texts.utils";
import type { ExitsOrderData } from "@/types/types.d";

const ExitsOrderInfo = ({ orderInfo }: { orderInfo: ExitsOrderData }) => {
  return (
    <>
      <div className="w-full grid grid-cols-2 m gap-x-4 mb-4">
        <div className="min-w-0">
          <InputText
            readOnly
            label={literals.orderOut}
            value={formatOptionalText(orderInfo.orderOut)}
            placeholder=""
            size="medium"
          />
        </div>
        <div className="min-w-0">
          <InputText
            readOnly
            label={literals.serialOut}
            value={formatOptionalText(orderInfo.serialOut)}
            placeholder=""
            size="medium"
          />
        </div>
      </div>
      <div className="w-full mb-4 pb-4 border-b border-ib-pt-color-gray-300 md:pr-[calc(50%+8px)]">
        <InputText
          readOnly
          label={literals.client}
          value={formatOptionalText(orderInfo.customer)}
          placeholder=""
          size="medium"
        />
      </div>
      <div className="w-full mb-4 font-ib-bold">{literals.packaging}</div>
      <div className="w-full mb-4 md:w-[calc(50%-8px)]">
        <InputText
          readOnly
          label={literals.packagingRef}
          value={formatOptionalText(orderInfo.packagingReference)}
          placeholder=""
          size="medium"
        />
      </div>
      <div className="w-full grid grid-cols-3 gap-x-4 mb-4">
        <div className="min-w-0">
          <InputText
            readOnly
            label={literals.own}
            value={formatBooleanText(orderInfo.ownPackaging)}
            placeholder=""
            size="medium"
          />
        </div>
        <div className="min-w-0">
          <InputText
            readOnly
            label={literals.correct}
            value={formatBooleanText(orderInfo.correctPackaging)}
            placeholder=""
            size="medium"
          />
        </div>
        <div className="min-w-0">
          <InputText
            readOnly
            label={literals.damaged}
            value={formatBooleanText(orderInfo.damagedPackaging)}
            placeholder=""
            size="medium"
          />
        </div>
      </div>
      {orderInfo.step === literals.presendsAction ? (
        <>
          <div className="w-full mb-4">
            <InputCheckbox
              id="ownPackagingOut"
              title={literals.ownPackagingOut}
              checked={orderInfo.ownPackagingOut}
              disabled
            />
          </div>
          <div className="w-full">
            <InputCheckbox
              id="iberiaPackaging"
              title={literals.iberiaPackaging}
              checked={orderInfo.iberiaPackagingOut}
              disabled
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default ExitsOrderInfo;
